function getVisibleCards() {
    if( window.innerWidth < 600 ) { return 1; }
    if( window.innerWidth < 900 ) { return 2; }
    return 3;
}

function createBookCarousel( el ){

    const track = el.querySelector( ".bookviewer-carousel-track" );
    const cards = el.querySelectorAll( ".bookviewer-carousel-card" );

    const next = el.querySelector( ".bookviewer-control-next" );
    const prev = el.querySelector( ".bookviewer-control-prev" );

    const indicatorsContainer =
        el.querySelector( ".bookviewer-carousel-indicators" );

    if( !track || !cards.length ) { return; }

    let index = 0;
    let visible = getVisibleCards();

    function updateIndicators(){

        if( !indicatorsContainer ) { return; }

        const indicators =
            indicatorsContainer.querySelectorAll( "span" );

        indicators.forEach( ( dot, i ) => {
            dot.classList.toggle( "active", i === index );
        })
    }

    function updateCarousel(){

        if( index < 0 ) { index = 0; }

        const maxIndex = Math.max( cards.length - visible, 0 );

        if( index > maxIndex ) { index = maxIndex; }

        const gap = parseInt( getComputedStyle( track ).gap ) || 0;
        const cardWidth = cards[0].offsetWidth + gap;

        track.style.transform =
            `translateX(-${index * cardWidth}px)`;

        updateIndicators();
    }

    function createIndicators(){

        if( !indicatorsContainer ) { return; }

        const totalSlides = Math.max( cards.length - visible + 1, 1 );

        indicatorsContainer.innerHTML = "";

        for( let i = 0; i < totalSlides; i++ ){

            const indicator = document.createElement( "span" );

            if( i === index ){
                indicator.classList.add( "active" );
            }

            indicator.addEventListener( "click", () => {
                index = i;
                updateCarousel();
            });

            indicatorsContainer.appendChild( indicator );
        }
    }

    function move( step ){
        index += step;
        updateCarousel();
    }

    const resizeObserver = new ResizeObserver( () => {

        visible = getVisibleCards();

        const maxIndex = Math.max( cards.length - visible, 0 );

        if( index > maxIndex ){
            index = maxIndex;
        }

        createIndicators();
        updateCarousel();

    });

    resizeObserver.observe( el );

    next?.addEventListener( "click", () => move(1)  );
    prev?.addEventListener( "click", () => move(-1) );

    createIndicators();
    updateCarousel();
}

function initBookDropdowns(){

    const dropdowns =
        document.querySelectorAll(".bookviewer-dropdown");

    dropdowns.forEach( dropdown => {

        const button =
            dropdown.querySelector(".bookviewer-dropdown-toggle");

        button.addEventListener("click", (e) => {

            e.stopPropagation();

            const isOpen = dropdown.classList.toggle("open");

            button.setAttribute("aria-expanded", isOpen ? "true" : "false");

        });

    });

    document.addEventListener("click", () => {

        document
            .querySelectorAll(".bookviewer-dropdown.open")
            .forEach(d => {
                d.classList.remove("open");
                const btn = d.querySelector(".bookviewer-dropdown-toggle");
                if( btn ) btn.setAttribute("aria-expanded", "false");
            });

    });

}

function initBookCarousel( selector = ".bookviewer-wrapper" ){

    const elements = document.querySelectorAll( selector );

    elements.forEach( el => {
        createBookCarousel( el );
    });

    initBookDropdowns();
}

export { initBookCarousel };